/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFDomain } from './CRSFDomain';
import {
    CRSFDomainFromJSON,
    CRSFDomainFromJSONTyped,
    CRSFDomainToJSON,
} from './CRSFDomain';

/**
 * 
 * @export
 * @interface CRSFDomainPagedResponse
 */
export interface CRSFDomainPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFDomainPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFDomainPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFDomain>}
     * @memberof CRSFDomainPagedResponse
     */
    results?: Array<CRSFDomain>;
    /**
     * 
     * @type {number}
     * @memberof CRSFDomainPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFDomainPagedResponse interface.
 */
export function instanceOfCRSFDomainPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFDomainPagedResponseFromJSON(json: any): CRSFDomainPagedResponse {
    return CRSFDomainPagedResponseFromJSONTyped(json, false);
}

export function CRSFDomainPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDomainPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFDomainFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFDomainPagedResponseToJSON(value?: CRSFDomainPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFDomainToJSON)),
        'total': value.total,
    };
}

